import React from 'react'
import * as S from './style'
import partner1 from 'assets/images/button/partner1.png'
import partner2 from 'assets/images/button/partner2.png'
import partner3 from 'assets/images/button/partner3.png'
import partner4 from 'assets/images/button/partner4.png'
import { useHistory } from 'react-router-dom'
import { UrlInternal } from 'common/constants/endpoints'
interface innitData {
  id: number
  image: string
  title1: string
  title2: string
}
function CustomPartner() {
  const history = useHistory()
  const data: innitData[] = [
    {
      id: 1,
      image: partner1,
      title1: '파트너를 모십니다.',
      title2: '파트너 제휴 문의'
    },
    {
      id: 2,
      image: partner2,
      title1: '궁금한 점이 있으세요?',
      title2: '자주 묻는 질문'
    },
    {
      id: 3,
      image: partner3,
      title1: '365 게임문의',
      title2: ' '
    },
    {
      id: 4,
      image: partner4,
      title1: '365 게임문의',
      title2: ' '
    }
  ]
  return (
    <S.container>
      {data &&
        data.map((i: innitData) => {
          return (
            <S.Box
              onClick={() => history.push(UrlInternal.CUSTOMER_CENTER)}
              key={i.id}
            >
              <S.AvatarImg>
                <img src={i.image} alt='avatar' />
              </S.AvatarImg>
              <div className='box-title'>
                <span className='box-title1'>{i.title1}</span>
                {i.title2 ? (
                  <span className='box-title2'>{i.title2}</span>
                ) : (
                  <React.Fragment></React.Fragment>
                )}
              </div>
            </S.Box>
          )
        })}
    </S.container>
  )
}

export default CustomPartner
